import HelpIcon from '@mui/icons-material/Help';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
/**
 * A wrapper component that conditionally shows a tooltip (text or HTML) next to its children.
 *
 * @param {FormTooltipProps} props - The properties for the tooltip wrapper.
 * @param {TooltipConfig} [props.tooltip] - Tooltip configuration object with `text` or `html`.
 * @param {SxProps} [props.sx] - Custom styles applied to the tooltip container.
 * @param {React.ReactNode} props.children - The main content to display next to the tooltip.
 * @returns {JSX.Element} A tooltip-enhanced element if `tooltip` is provided, otherwise just the children.
 */
export const FormTooltip = ({ tooltip = {}, sx, children }) => {
    const { html, text } = tooltip;
    if (!(html || text)) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(Box, { display: 'flex', alignItems: 'center' },
        children,
        React.createElement(Tooltip, { title: html ? (React.createElement(Typography, { component: 'div', dangerouslySetInnerHTML: { __html: html }, "data-test": 'tooltip-html' })) : (React.createElement(Typography, { "data-test": 'tooltip-text' }, text)), sx: Object.assign({ ml: 1 }, sx) },
            React.createElement(IconButton, { size: 'medium', "data-test": 'tooltip-button', "aria-label": 'Additional Information' },
                React.createElement(HelpIcon, { fontSize: 'medium' })))));
};
